const IconApprove = ({ className }) => {
    return (
        <svg
            width='36'
            height='24'
            viewBox='0 0 36 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <g id='Approve users icon' clipPath='url(#clip0_4744_5662)'>
                <path
                    id='Vector'
                    d='M18.5988 22.7793V20.3839C18.5988 19.1133 18.0941 17.8948 17.1956 16.9963C16.2972 16.0979 15.0786 15.5931 13.808 15.5931H6.62185C5.35125 15.5931 4.13269 16.0979 3.23425 16.9963C2.3358 17.8948 1.83105 19.1133 1.83105 20.3839V22.7793'
                    stroke='white'
                    strokeWidth='2.3954'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    id='Vector_2'
                    d='M10.2151 10.8023C12.861 10.8023 15.0059 8.65738 15.0059 6.0115C15.0059 3.36562 12.861 1.2207 10.2151 1.2207C7.56923 1.2207 5.42432 3.36562 5.42432 6.0115C5.42432 8.65738 7.56923 10.8023 10.2151 10.8023Z'
                    stroke='white'
                    strokeWidth='2.3954'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    id='Vector_3'
                    d='M25.785 22.7791V20.3838C25.7842 19.3223 25.4309 18.2911 24.7806 17.4522C24.1302 16.6132 23.2197 16.014 22.1919 15.7487'
                    stroke='white'
                    strokeWidth='2.3954'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    id='Vector_4'
                    d='M18.5986 1.37628C19.6292 1.64014 20.5425 2.23946 21.1948 3.07978C21.8471 3.9201 22.2011 4.9536 22.2011 6.01737C22.2011 7.08113 21.8471 8.11463 21.1948 8.95495C20.5425 9.79527 19.6292 10.3946 18.5986 10.6584'
                    stroke='white'
                    strokeWidth='2.3954'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    id='Vector_5'
                    d='M26.9829 9.6046L29.3783 12L34.1691 7.2092'
                    stroke='white'
                    strokeWidth='2.3954'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
            <defs>
                <clipPath id='clip0_4744_5662'>
                    <rect width='34.7333' height='23.954' fill='white' transform='translate(0.633301 0.0230103)' />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconApprove;
